document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', (event) => {
      event.currentTarget.form.submit();
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addButtonText = section.querySelector('[data-add-to-cart-text]');

    if (!variantSelect) return;

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      const comparePrice = option.dataset.comparePrice;

      if (price) {
        price.innerHTML = `<span>${option.dataset.price}</span>${comparePrice ? `<s>${comparePrice}</s>` : ''}`;
      }

      if (addButton) addButton.disabled = !available;
      if (addButtonText) addButtonText.textContent = available ? 'Add to cart' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('.mobile-menu__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('.mobile-menu');
      if (menu) menu.removeAttribute('open');
    });
  });
});
